import { Box, Typography, CardMedia } from '@mui/material';
import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';
import SectionTitle from '../../components/SectionTitle';
import Form from 'components/Form';
import one from 'assets/pain-location.svg';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const PainLocation = (props: Props) => {
  const { disabled, register } = props;

  return (
    <>
      <SectionTitle title="1. 통증 부위" mt={3} />
      <Box sx={{ width: '98%', margin: '48px 0 0 0' }}>
        <Typography
          sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '10px' }}
        >
          현재 통증이 있는 부위를 Body chart를 참고하여 작성해주세요.
        </Typography>
        <Form.MuiTextField
          disabled={disabled}
          fullWidth
          multiline
          minRows={1}
          required={false}
          placeholder="ex. 우상 하복부"
          {...register('no_1')}
        />
        <CardMedia
          height={300}
          component="img"
          image={one}
          sx={{ objectFit: 'contain', width: 'auto', margin: '10px 0 30px 0' }}
        />
      </Box>
    </>
  );
};

export default PainLocation;
